
define('text!templates/modules/calendar/animated-session/exercise/weight/history/weight-history-content.html',[],function () { return '<table class="exercise-weight-table table">\n</table>\n';});

